import React, { Component } from 'react';
//Styles
import './Contact.css';
//Tools
import { Control, LocalForm, Errors } from 'react-redux-form';
import { Label, Button } from 'reactstrap';
//Image & Icons
import ContactBG from '../../images/contact_bg.mp4';
import { faMobile, faEnvelope} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//Components
import Header from '../Header/Header';


const required = value => value && value.length;
const maxLength = len => value => !value || (value.length <= len);
const minLength = len => value => value && (value.length >= len);
const isNumber = val => !isNaN(+val);
const validEmail = val => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val);

class Contact extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            phone: '',
            email: '',
            agree: false,
            contactType: 'Select',
            feedback: '',
            touched: {
                name: false,
                phone: false,
                email: false
            }
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(values) {
        console.log("Feedback : "+ JSON.stringify(values));
        if (values.agree) {
            if (values.contactType === 'By Phone') {
                const contactMethod = values.phone;
                alert(`Thank you for submitting, ${values.name}! We will contact you ${contactMethod}`);

            } else {
                const contactMethod = values.email;
                alert(`Thank you for submitting, ${values.name}! We will contact you ${contactMethod}`);
            }
        } else {
        alert(`Thank you for submitting, ${values.name}!`)
        }
    }

    render() {

        return (
            <>
                <Header color={'var(--White)'} barColor={'var(--Lime)'} bg={'none'}/>

                <div className="contact__background">
                    <video  autoPlay loop muted> 
                        <source src={ContactBG} type='video/mp4' />
                    </video>
                </div>
                <div className="contact__wrapper">
                    <div className="contact__content">
                        <div className="contact__title">
                            <h1>Talk to us! We are here 24/7 for you!</h1>
                            <h3>Please leave us any inquiry or feedback.<br/>
                                Our team will reach you within 24 hours
                            </h3>
                        </div>
                        <div className="contact__form">
                            <div className="left">
                                <div className="address">
                                    <h2>transia</h2>
                                    <h3>1280 Braddock Road<br/>
                                        Fairfax, VA 22031<br/>
                                        U.S.A.
                                    </h3>
                                </div>
                                <div className="contacts">
                                    <p>
                                        <a role="button" href="tel:+15713990123">
                                            <FontAwesomeIcon icon={faMobile} className="icon" />
                                            +1 571-399-0123 
                                        </a>
                                    </p>
                                    <p>
                                        <a role="button" href="mel:info@transia.com">
                                            <FontAwesomeIcon icon={faEnvelope} className="icon" />
                                            info@transia.com
                                        </a>
                                    </p>
                                </div>
                            </div>
                            <div className="right">
                                <LocalForm onSubmit={values => this.handleSubmit(values)} action="/">
                                    <div className="form-group">
                                        <Control.text 
                                            model=".name"
                                            id="name"
                                            name="name"
                                            placeholder="Full name"
                                            className="form__info"
                                            validators={{
                                                required,
                                                minLength: minLength(2),
                                                maxLength: maxLength(30)
                                            }}
                                        />
                                        <Errors
                                            className="text-danger"
                                            model=".name"
                                            show="touched"
                                            component="div"
                                            messages={{
                                                required: 'Required',
                                                minLength: 'Must be at least 2 characters',
                                                maxLength: 'Must be 30 characters or less'
                                            }}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <Control.text 
                                            model=".phone"
                                            id="phone"
                                            name="phone"
                                            placeholder="phone, numbers only"
                                            className="form__info"
                                            validators={{
                                                required,
                                                minLength: minLength(10),
                                                maxLength: maxLength(15),
                                                isNumber
                                            }}
                                        />
                                        <Errors
                                            className="text-danger"
                                            model=".phone"
                                            show="touched"
                                            component="div"
                                            messages={{
                                                required: 'Required',
                                                minLength: 'Must be at least 10 characters',
                                                maxLength: 'Must be 15 characters or less',
                                                isNumber: 'Must be only numbers'
                                            }}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <Control.text 
                                            model=".email"
                                            id="email"
                                            name="email"
                                            placeholder="email"
                                            className="form__info"
                                            validators={{
                                                required,
                                                validEmail
                                            }}
                                        />
                                        <Errors
                                            className="text-danger"
                                            model=".email"
                                            show="touched"
                                            component="div"
                                            messages={{
                                                required: 'Required',
                                                validEmail: 'Invalid email address'
                                            }}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <div className="form__check">
                                            <Label check className="form__check__label">
                                                <Control.checkbox
                                                    model=".agree"
                                                    className="form__checkbox"
                                                    name="agree"
                                                /> {''}
                                                <span className='check__label'>Contact me </span>
                                            </Label>
                                            <Control.select
                                                model=".contactType"
                                                name="contactType"
                                                className="form__option"
                                            >
                                                <option className='form__option' unselectable>select</option>
                                                <option className='form__option'>By Phone</option>
                                                <option className='form__option'>By Email</option>
                                            </Control.select>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <Control.textarea
                                            model=".feedback"
                                            id="feedback"
                                            name="feedback"
                                            rows="8"
                                            className="form__feedback"
                                            placeholder="feedback or inquiry"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <Button type="submit" >SEND FEEDBACK</Button>
                                    </div>
                                </LocalForm>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        )


    }


}

export default Contact;